import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import TransactionSummary from './TransactionSummaryContainer';
import { fetchTransactionSummary } from 'redux/transactionSummary/TransactionSummaryActions';

const mapStateToProps = ({ transactionSummary }) => ({
  fetchingTransactionSummary: transactionSummary.fetchingTransactionSummary,
  transactions: transactionSummary.transactions
});

const mapDispatchToProps = dispatch => ({
  transactionSummaryActions: bindActionCreators({ fetchTransactionSummary }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(TransactionSummary);



// WEBPACK FOOTER //
// ./src/components/dashboard/comp/transactionSummary/TransactionSummaryConnector.js